import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/tickets/$ticketId")({
  head: () => ({ meta: [{ title: "Support Ticket | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/account-tickets-ticketId")),
});
